"use client";

import { Provider } from "jotai/react";
import { type ReactNode } from "react";

import { getJotaiStore } from "#/utils/getJotaiStore";

interface JotaiProviderProps {
  children?: ReactNode;
}

export const JotaiProvider: React.FC<JotaiProviderProps> = ({ children }) => {
  const store = getJotaiStore();

  return <Provider store={store}>{children}</Provider>;
};
